module.exports = __webpack_public_path__ + "img/03_noff_close_L2.6170a2a6.svg";